<div class="ledger-inquiry">
  <fieldset class="rms-fieldset filters">
    <legend>Search</legend>
    <div class="filter-grid">
      <rms-date name="FromDate" label="From" [disabled]="ReviewMode" [(ngModel)]="Filters.FromDate"></rms-date>
      <rms-date name="ThroughDate" label="Through" [disabled]="ReviewMode" [(ngModel)]="Filters.ThroughDate"></rms-date>
      <rms-select name="AccountID" label="Account" [includeSearch]="true" [options]="AccountOptions" [(ngModel)]="Filters.AccountID"></rms-select>
      <rms-select name="AccountTypeID" label="Account Type" [options]="AccountTypeOptions" [(ngModel)]="Filters.AccountTypeID"></rms-select>
      <rms-select name="SourceType" label="Source" [options]="SourceTypeOptions" [(ngModel)]="Filters.SourceType"></rms-select>
      <rms-select name="PaymentMethodID" label="Payment Method" [options]="PaymentMethodOptions" [(ngModel)]="Filters.PaymentMethodID"></rms-select>
      <rms-select name="CompanyID" label="Customer" [includeSearch]="true" [options]="CustomerOptions" [(ngModel)]="Filters.CompanyID"></rms-select>
      <rms-select name="Status" label="Status" [options]="StatusOptions" [(ngModel)]="Filters.Status"></rms-select>
      <rms-input name="Reference" label="Reference" placeholder="Entry, invoice, check or charge #" [(ngModel)]="Filters.Reference" (keyup.enter)="search()"></rms-input>
      <rms-input name="SearchText" label="Search" placeholder="Description, payee or customer" [(ngModel)]="Filters.SearchText" (keyup.enter)="search()"></rms-input>
    </div>
    <div class="filter-actions">
      <rms-checkbox label="Show only dates needing review" [ngModel]="ReviewMode" (ngModelChange)="toggleReviewMode($event)"></rms-checkbox>
      <span class="spacer"></span>
      <button mat-button class="btn-bg-yellow" (click)="clearFilters()">Clear</button>
      <button mat-button class="btn-bg-green" [disabled]="Loading" (click)="search()">Search</button>
    </div>
    @if (DataRange) {
    <p class="data-range">Ledger data available {{ DataRange.FirstDate | date:'MM/dd/yyyy':'UTC' }} – {{ DataRange.LastDate | date:'MM/dd/yyyy':'UTC' }}.</p>
    }
  </fieldset>

  @if (Loading) {
  <p class="loading-message" role="status">Loading ledger…</p>
  }

  @if (Summary) {
  <div class="summary-cards">
    <div class="summary-card">
      <div class="summary-label">Opening balance</div>
      <div class="summary-value" [class.negative]="Summary.OpeningBalance < 0">{{ Summary.OpeningBalance | currency:'USD' }}</div>
    </div>
    <div class="summary-card">
      <div class="summary-label">Deposits</div>
      <div class="summary-value">{{ Summary.PeriodDeposits | currency:'USD' }}</div>
    </div>
    <div class="summary-card">
      <div class="summary-label">Withdrawals</div>
      <div class="summary-value">{{ Summary.PeriodWithdrawals | currency:'USD' }}</div>
    </div>
    <div class="summary-card">
      <div class="summary-label">Closing balance</div>
      <div class="summary-value" [class.negative]="Summary.ClosingBalance < 0">{{ Summary.ClosingBalance | currency:'USD' }}</div>
    </div>
    <div class="summary-card">
      <div class="summary-label">Records</div>
      <div class="summary-value">{{ Summary.RecordCount | number }}</div>
    </div>
  </div>

  @if (!ReviewMode && Summary.ReviewRowsInOpening > 0) {
  <div class="review-banner" role="status">
    <mat-icon>info</mat-icon>
    <span>
      Opening balance includes {{ Summary.ReviewRowsInOpening }} entries with dates needing review (net {{ Summary.ReviewNetInOpening | currency:'USD' }}).
      @if (Summary.MissingDateCount > 0) {
      {{ Summary.MissingDateCount }} entries with no date are not included in any balance.
      }
    </span>
    <button mat-button class="btn-bg-blue" (click)="toggleReviewMode(true)">Review them</button>
  </div>
  }
  @if (ReviewMode) {
  <div class="review-banner" role="status">
    <mat-icon>info</mat-icon>
    <span>Showing {{ Summary.DateNeedsReviewCount }} entries with a missing date ({{ Summary.MissingDateCount }}) or a date before 1990 ({{ Summary.Pre1990Count }}). Date filters are ignored in this view.</span>
    <button mat-button class="btn-bg-blue" (click)="toggleReviewMode(false)">Back to search</button>
  </div>
  }

  <rms-table [data]="Rows"
             [columns]="Columns"
             [HeaderButtons]="Buttons"
             [clickableRow]="true"
             (onRowClick)="openTransaction($event.row)"
             tableId="ledger-inquiry"
             startSort="TransactionDate"
             startSortDirection="asc">
  </rms-table>
  }
</div>
